import AbstractEntity from "../AbstractEntity";

export default class CompanyAddress extends AbstractEntity {
    _id;
    _line1;
    _line2;
    _line3;
    _postcode;
    _city;
    _companyId;

    getId() {
        return this._id;
    }

    getLine1() {
        return this._line1;
    }

    getLine2() {
        return this._line2;
    }

    getLine3() {
        return this._line3;
    }

    getPostcode() {
        return this._postcode;
    }

    getCity() {
        return this._city;
    }

    getCompanyId() {
        return this._companyId;
    }


    getClassName() {
        return "company_address";
    }
}